import { useAuth } from "@/context/AuthContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

export default function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/", { replace: true });
  }, [user, navigate]);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-[#00133F] p-12 text-white relative overflow-hidden">
        <div className="absolute -bottom-20 -right-20 w-80 h-80 rounded-full bg-[#F0005A]/20 blur-3xl" />
        <div className="flex items-center gap-2 relative">
          <div className="w-9 h-9 rounded-xl bg-white/10 flex items-center justify-center">
            <div className="w-4 h-4 border-2 border-[#F0005A] rounded-sm rotate-45" />
          </div>
          <span className="font-heading font-extrabold text-lg">ROOFTOP <span className="text-[#F0005A]">PRINT</span></span>
        </div>
        <div className="relative">
          <h1 className="font-heading text-4xl font-bold leading-tight mb-4">
            Cetak apa saja,<br /><span className="text-[#F0005A]">langsung dari desainmu.</span>
          </h1>
          <p className="text-slate-300 max-w-md leading-relaxed">
            Masuk untuk mengunggah desain, melihat pratinjau langsung pada mockup produk,
            dan menyelesaikan pesananmu dengan aman.
          </p>
        </div>
        <div className="relative text-slate-400 text-sm">Mug Custom • Plakat Akrilik • Kirim ke Seluruh Indonesia</div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#F0005A]/10 text-[#F0005A] text-xs font-semibold mb-6">
            <Sparkles className="w-3.5 h-3.5" /> Selamat datang
          </div>
          <h2 className="font-heading text-3xl font-bold text-[#00133F] mb-2">Masuk ke akun</h2>
          <p className="text-slate-500 mb-8 text-sm">Gunakan akun Google untuk melanjutkan.</p>

          <Button data-testid="google-login-btn" onClick={handleGoogleLogin}
            className="w-full h-12 rounded-full bg-white border border-slate-200 text-[#00133F] hover:bg-slate-50 shadow-sm text-base font-medium">
            <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            Lanjutkan dengan Google
          </Button>
          <p className="text-xs text-slate-400 text-center mt-6">
            Dengan masuk, kamu menyetujui ketentuan layanan ROOFTOP PRINT.
          </p>
        </div>
      </div>
    </div>
  );
}
